'use client';

import { IconScaleTwo } from '@vs-shop/ui/icons';
import type { ClassValue } from 'clsx';
import {
  ProductPanelTool,
  ProductPanelToolLabel,
  ProductPanelToolVariant,
  productPanelToolMarkVariants,
} from '@vs-shop/commerce-ui/productPanelTools';
import { clsxm } from '@vs-shop/utils';
import { useIntl } from 'react-intl';

import { addProductCodeAtom } from '@vs-shop/engine/atom/productsComparison/productsComparison';
import { useAtomSet } from '@effect/atom-react';

type Props = {
  productCode: string;
  onAddedAction: () => void;
  className?: ClassValue;
};

export default function ProductPanelComparisonAdd({
  productCode,
  onAddedAction,
  className,
}: Props) {
  const intl = useIntl();

  const addToComparison = useAtomSet(addProductCodeAtom);

  const handleAddToComparison = () => {
    addToComparison(productCode);
    onAddedAction();
  };

  return (
    // The comparison set is a toggle, and this is its off state: said once, as
    // `aria-pressed`, rather than left to the label a sighted shopper reads.
    <ProductPanelTool
      onClick={handleAddToComparison}
      aria-pressed={false}
      className={clsxm(className)}
    >
      <IconScaleTwo
        className={clsxm(
          'size-6',
          productPanelToolMarkVariants({ variant: ProductPanelToolVariant.DEFAULT })
        )}
      />
      <ProductPanelToolLabel variant={ProductPanelToolVariant.DEFAULT}>
        {intl.formatMessage({
          id: 'component.server.page.product.panel.productPanelCompareFavorite.compare',
          defaultMessage: 'Porovnat',
        })}
      </ProductPanelToolLabel>
    </ProductPanelTool>
  );
}
